import { BREADCRUMB_VARIANT } from './Breadcrumb.constants'

export function formatItemsCount(itemsCount) {
  return `(${itemsCount})`
}

export function checkIsBreadCrumbTabVariant(variant) {
  return variant === BREADCRUMB_VARIANT.TAB
}
